import { createSlice } from "@reduxjs/toolkit";
import { generateUniqueId } from "../../utils/generateUniqueId";

const initialState = {
  alerts: [],
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    successAlert: (state, { payload }) => {
      const key = `success-${generateUniqueId()}`;
      state.alerts.push({
        key,
        title: payload?.title || "Success",
        severity: "success",
        message: String(payload?.message ?? ""),
      });
    },
    errorAlert: (state, { payload }) => {
      const key = `error-${generateUniqueId()}`;
      state.alerts.push({
        key,
        title: payload?.title || "Error",
        severity: "error",
        message: String(payload?.message ?? ""),
      });
    },
    warningAlert: (state, { payload }) => {
      const key = `warning-${generateUniqueId()}`;
      state.alerts.push({
        key,
        title: payload?.title || "Warning",
        severity: "warning",
        message: String(payload?.message ?? ""),
      });
    },
    infoAlert: (state, { payload }) => {
      const key = `info-${generateUniqueId()}`;
      state.alerts.push({
        key,
        title: payload?.title || "Info",
        severity: "info",
        message: String(payload?.message ?? ""),
      });
    },
    /** Remove one alert by key, or the first in queue if key omitted */
    removeAlert: (state, { payload }) => {
      const key = payload?.key;
      if (key) {
        state.alerts = state.alerts.filter((a) => a.key !== key);
      } else {
        state.alerts.shift();
      }
    },
    clearAlerts: (state) => {
      state.alerts = [];
    },
  },
});

export const {
  successAlert,
  errorAlert,
  warningAlert,
  infoAlert,
  removeAlert,
  clearAlerts,
} = appSlice.actions;

export default appSlice.reducer;
